import { ReportProfileDelegateAccess } from '../../../profile/report-profile-delegate-access';

export class ZimbraMailingReportProfileDelegate extends ReportProfileDelegateAccess {
}
